// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2tRWj","fileDisabled":"File_fileDisabled__2pYFV"};